"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtbxInterval = void 0;
const _ = require("lodash");
const intervalFormulas_1 = require("./intervalFormulas");
class RtbxInterval {
    constructor(params) {
        this.formulas = intervalFormulas_1.IntervalFormulas.getFormulas({ dspNumbersBilled: params.bidderBillingSource });
        Object.assign(this, {
            imps: parseInt(params.renders),
            impsAdj: this.getImpsAdjOriginal(params),
            impsAdjOriginal: this.getImpsAdjOriginal(params),
            impsDisc: this.getImpsDiscOriginal(params),
            impsDiscOriginal: this.getImpsDiscOriginal(params),
            rev: parseFloat(params.dfp_revenue),
            revAdj: this.getRevAdjOriginal(params),
            revAdjOriginal: this.getRevAdjOriginal(params),
            revDisc: this.getRevDiscOriginal(params),
            revDiscOriginal: this.getRevDiscOriginal(params),
        });
    }
    // gets based on header and metric names
    getBaseMetric(header) {
        // "imps" or "rev"
        if (header.toLowerCase().indexOf('disc') > -1) {
            return header.toLowerCase().split('disc')[0];
        }
        else if (header.toLowerCase().indexOf('adj') > -1) {
            return header.toLowerCase().split('adj')[0];
        }
        else {
            return '';
        }
    }
    getRawMetricToCalculate(header) {
        // "impsAdj" or "revAdj"
        if (header.toLowerCase().indexOf('disc') > -1) {
            return `${header.toLowerCase().split('disc')[0]}Adj`;
        }
        return header;
    }
    // get original values
    getImpsAdjOriginal(params) {
        return isNaN(parseInt(params.helm_renders)) ? null : Math.round(params.helm_renders);
    }
    getImpsDiscOriginal(params) {
        let impsDisc = this.formulas.getImpsDisc(params.renders, params.helm_renders);
        return isNaN(impsDisc) ? null : impsDisc;
    }
    getRevAdjOriginal(params) {
        return isNaN(parseFloat(params.helm_dfp_revenue)) ? null : parseFloat(params.helm_dfp_revenue);
    }
    getRevDiscOriginal(params) {
        let revDisc = this.formulas.getRevDisc(params.dfp_revenue, params.helm_dfp_revenue);
        return isNaN(revDisc) ? null : revDisc;
    }
    // get the value that needs to be updated when this value is changed
    getImpsDiscChanged() {
        let impsAdj = this.formulas.getImpsAdj(this.imps, this.impsDisc);
        this.impsAdj = isNaN(impsAdj) ? null : impsAdj;
    }
    getImpsAdjChanged() {
        let impsDisc = this.formulas.getImpsDisc(this.imps, this.impsAdj);
        this.impsDisc = isNaN(impsDisc) ? null : impsDisc;
    }
    getRevDiscChanged() {
        let revAdj = this.formulas.getRevAdj(this.rev, this.revDisc);
        this.revAdj = isNaN(revAdj) ? null : revAdj;
    }
    getRevAdjChanged() {
        let revDisc = this.formulas.getRevDisc(this.rev, this.revAdj);
        this.revDisc = isNaN(revDisc) ? null : revDisc;
    }
    impsAdjDiff() {
        return this.impsAdj !== this.impsAdjOriginal;
    }
    revAdjDiff() {
        return this.revAdj !== this.revAdjOriginal;
    }
    update({ metric, value }) {
        this[metric] = value;
    }
    calculateRow() {
        this.calculateCpmMetrics();
    }
    calculateCpmMetrics() {
        this.calculateCpm();
        this.calculateAdjustedCpm();
        this.calculateCpmDiscrepancy();
    }
    calculateCpm() {
        this.cpm = Number(((this.rev / this.imps) * 1000).toFixed(2));
    }
    calculateAdjustedCpm() {
        let rev = null;
        let imps = null;
        if (this.revAdj === null) {
            rev = this.rev;
        }
        else if (_.isNumber(Number(this.revAdj))) {
            rev = this.revAdj;
        }
        if (this.impsAdj === null) {
            imps = this.imps;
        }
        else if (_.isNumber(Number(this.impsAdj))) {
            imps = this.impsAdj;
        }
        this.cpmAdj = (((rev / (imps))) * 1000);
        this.cpmAdj = Number(this.cpmAdj.toFixed(2));
    }
    calculateCpmDiscrepancy() {
        this.cpmDisc = this.formulas.getCpmDisc(this.cpm, this.cpmAdj);
    }
}
exports.RtbxInterval = RtbxInterval;
//# sourceMappingURL=rtbxInterval.js.map